export default "__VITE_ASSET__DtwO6UPu__"